import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Alert } from '@mui/material';
import { verifyMagicLink } from '../store/authSlice.js';
import type { RootState, AppDispatch } from '../store/index.js';
import LoadingSpinner from '../components/LoadingSpinner.js';

export default function AuthVerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { loading, error, user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      dispatch(verifyMagicLink(token));
    }
  }, [searchParams, dispatch]);

  useEffect(() => {
    if (user) {
      const timer = setTimeout(() => navigate('/scan'), 1000);
      return () => clearTimeout(timer);
    }
  }, [user, navigate]);

  if (loading) {
    return <LoadingSpinner message="Login wird verifiziert..." />;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 4 }}>
      {error ? (
        <Alert severity="error" sx={{ maxWidth: 500 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>Verifizierung fehlgeschlagen</Typography>
          <Typography variant="body2">{error}</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            <a href="/login" style={{ textDecoration: 'underline' }}>Zurück zum Login</a>
          </Typography>
        </Alert>
      ) : user ? (
        <Alert severity="success" sx={{ maxWidth: 500 }}>
          <Typography variant="h6">Erfolgreich eingeloggt!</Typography>
          <Typography variant="body2">Du wirst weitergeleitet...</Typography>
        </Alert>
      ) : (
        <Alert severity="warning" sx={{ maxWidth: 500 }}>
          <Typography variant="body2">Kein Token gefunden. Bitte verwende den Link aus deiner E-Mail.</Typography>
        </Alert>
      )}
    </Box>
  );
}
